// extracted by mini-css-extract-plugin
export default {"wrapper":"Catalogue_wrapper__Suq+W","image":"Catalogue_image__fxtLm","active":"Catalogue_active__L2dqN"};